<template>
	<div class="app-container">
		<!-- 搜索过滤 -->
		<el-card class="filter-card">
			<el-form :inline="true" :model="filterForm" class="filter-form">
				<el-form-item>
					<el-button type="primary" @click="handleAdd">
						<el-icon>
							<Plus />
						</el-icon> 新建回款
					</el-button>
				</el-form-item>
				<el-form-item>
					<el-divider direction="vertical"></el-divider>
				</el-form-item>
				<el-form-item label="回款编号">
					<el-input v-model="filterForm.number" placeholder="请输入回款编号" clearable @keyup.enter="handleSearch" />
				</el-form-item>
				<el-form-item label="客户名称">
					<!-- <el-input v-model="filterForm.customerName" placeholder="请输入客户名称" clearable @keyup.enter="handleSearch" /> -->
					<el-select v-model="filterForm.customerId" placeholder="请选择客户" filterable remote
						:remote-method="handleCustomerSearch" :loading="customerSearchLoading"
						@change="handleCustomerChange" clearable>
						<el-option v-for="item in customerOptions" :key="item.id" :label="item.customerName"
							:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="回款类型">
					<el-select v-model="filterForm.type" placeholder="请选择商机状态" style="width: 150px;">
						<el-option label="全部" value="all"></el-option>
						<el-option label="我的" value="my"></el-option>
						<el-option label="下属的" value="subordinate"></el-option>
					</el-select>
				</el-form-item>
				<!-- <el-form-item label="合同编号">
          <el-input v-model="filterForm.contractNo" placeholder="请输入合同编号" clearable @keyup.enter="handleSearch" />
        </el-form-item> -->
				<!-- <el-form-item label="回款状态">
          <el-select v-model="filterForm.status" placeholder="请选择状态" clearable>
            <el-option label="待审核" :value="0" />
            <el-option label="已通过" :value="1" />
            <el-option label="已拒绝" :value="2" />
          </el-select>
        </el-form-item> -->
				<!-- <el-form-item label="回款日期">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="YYYY-MM-DD">
          </el-date-picker>
        </el-form-item> -->
				<el-form-item>
					<el-button type="primary" @click="handleSearch">
						<el-icon>
							<Search />
						</el-icon> 搜索
					</el-button>
					<el-button @click="resetForm">
						<el-icon>
							<Refresh />
						</el-icon> 重置
					</el-button>
				</el-form-item>
			</el-form>
		</el-card>

		<!-- 回款列表 -->
		<el-card class="table-card">
			<el-table :data="paymentList" height="calc(100vh - 320px)" style="width: 100%" stripe v-loading="loading" ref="paymentTable">
				<el-table-column type="index" label="序号" width="60" />
				<el-table-column prop="number" label="回款编号" />
				<el-table-column prop="customerName" label="客户名称" />
				<el-table-column prop="contractNo" label="合同编号" />
				<el-table-column prop="money" label="回款金额" width="120">
					<template #default="scope">
						{{ formatAmount(scope.row.money) }}
					</template>
				</el-table-column>
				<el-table-column prop="returnTime" label="回款日期" width="120">
					<template #default="scope">
						{{ formatDate(scope.row.returnTime) }}
					</template>
				</el-table-column>
				<el-table-column prop="returnType" label="回款方式" width="100">
					<template #default="scope">
						{{ getPaymentMethodText(scope.row.returnType) }}
					</template>
				</el-table-column>
				<!-- <el-table-column prop="status" label="状态" width="100">
          <template #default="scope">
            <el-tag :type="getStatusType(scope.row.status)">
              {{ getStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column> -->
				<el-table-column label="操作" width="250" fixed="right">
					<template #default="scope">
						<el-button size="mini" type="info" @click="handleView(scope.row)">查看</el-button>
						<el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
						<el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
						<!-- <el-button
              v-if="scope.row.status === 0"
              size="mini"
              type="success"
              @click="handleSubmit(scope.row)">提交审核</el-button>
            <el-button
              v-if="scope.row.status === 0"
              size="mini"
              type="warning"
              @click="handleApprove(scope.row)">审核</el-button> -->
					</template>
				</el-table-column>
			</el-table>

			<div class="pagination-container">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
		</el-card>

		<!-- 新建/编辑回款对话框 -->
		<el-dialog :title="dialogTitle" v-model="dialogVisible" width="800px" :close-on-click-modal="false"
			:close-on-press-escape="false" destroy-on-close>
			<el-form :model="paymentForm" :rules="rules" ref="paymentForm" label-width="100px"
				v-loading="dialogLoading">
				<!-- 基本信息 -->
				<el-divider content-position="left">基本信息</el-divider>
				<el-form-item label="回款编号" prop="number">
					<el-input v-model="paymentForm.number" placeholder="请输入回款编号" />
				</el-form-item>
				<el-form-item label="客户名称" prop="customerId">
					<el-select v-model="paymentForm.customerId" placeholder="请选择客户" filterable remote
						:remote-method="handleCustomerSearch" :loading="customerSearchLoading"
						@change="handleCustomerChange">
						<el-option v-for="item in customerOptions" :key="item.id" :label="item.customerName"
							:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="所属商机" prop="businessId">
					<el-select v-model="paymentForm.businessId" placeholder="请选择商机" filterable
						:loading="opportunityLoading" @change="handleOpportunityChange">
						<el-option v-for="item in opportunityOptions" :key="item.id" :label="item.name"
							:value="item.id">
							<span>{{ item.name }}</span>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="所属合同" prop="contractId">
					<el-select v-model="paymentForm.contractId" placeholder="请选择合同" filterable
						:loading="contractLoading">
						<el-option v-for="item in contractOptions" :key="item.id" :label="item.contractNumber"
							:value="item.id">
							<span>{{ item.contractNumber }}</span>
							<span style="float: right; color: #8492a6; font-size: 13px">
								金额: {{ formatAmount(item.totalAmount) }}
							</span>
						</el-option>
					</el-select>
				</el-form-item>

				<!-- 回款信息 -->
				<el-divider content-position="left">回款信息</el-divider>
				<el-form-item label="回款金额" prop="money">
					<el-input-number v-model="paymentForm.money" :precision="2" :step="1000" :min="0"
						style="width: 200px" />
				</el-form-item>
				<el-form-item label="回款日期" prop="returnTime">
					<el-date-picker v-model="paymentForm.returnTime" type="date" placeholder="选择日期"
						value-format="YYYY-MM-DD">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="回款方式" prop="returnType">
					<el-select v-model="paymentForm.returnType" placeholder="请选择回款方式">
						<el-option label="银行转账" value="银行转账" />
						<el-option label="现金" value="现金" />
						<el-option label="支票" value="支票" />
						<el-option label="其他" value="其他" />
					</el-select>
				</el-form-item>

				<!-- 附件信息 -->
				<el-divider content-position="left">附件信息</el-divider>
				<el-form-item label="回款单" prop="receiptFile"
					:rules="[{ required: true, message: '请上传回款单', trigger: 'change' }]">
					<el-upload action="/api/move/uploadPic" :on-preview="handleReceiptFilePreview"
						:on-remove="handleReceiptFileRemove" :on-success="handleReceiptFileSuccess"
						:before-upload="beforeReceiptFileUpload" :headers="uploadHeaders" :limit="1"
						:on-exceed="handleReceiptFileExceed" :file-list="receiptFileList" accept=".pdf,.jpg,.jpeg,.png"
						class="receipt-upload">
						<el-button type="primary">选择文件</el-button>
						<template #tip>
							<div class="el-upload__tip">支持PDF、JPG、PNG格式</div>
						</template>
					</el-upload>
				</el-form-item>

				<!-- 其他信息 -->
				<el-divider content-position="left">其他信息</el-divider>
				<el-form-item label="备注说明" prop="remark">
					<el-input v-model="paymentForm.remark" type="textarea" :rows="2" placeholder="请输入备注说明" />
				</el-form-item>
			</el-form>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="dialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="submitForm" :loading="submitLoading">
						确 定
					</el-button>
				</span>
			</template>
		</el-dialog>

		<!-- 查看回款详情对话框 -->
		<el-dialog class="mydialog" title="回款详情" v-model="viewDialogVisible" width="50vw"
			:close-on-click-modal="false" align-center>
			<el-tabs v-model="activeTab">
				<el-tab-pane label="基本信息" name="basic">
					<el-descriptions :column="2" border>
						<!-- 基本信息 -->
						<el-descriptions-item label="回款编号">{{ viewPayment.number }}</el-descriptions-item>
						<el-descriptions-item label="客户名称">{{ viewPayment.customerName }}</el-descriptions-item>
						<el-descriptions-item label="所属商机">{{ viewPayment.businessName }}</el-descriptions-item>
						<el-descriptions-item label="所属合同">{{ viewPayment.contractNo }}</el-descriptions-item>

						<!-- 回款信息 -->
						<el-descriptions-item label="回款金额">{{ formatAmount(viewPayment.money) }}</el-descriptions-item>
						<el-descriptions-item
							label="回款日期">{{ formatDate(viewPayment.returnTime) }}</el-descriptions-item>
						<el-descriptions-item
							label="回款方式">{{ getPaymentMethodText(viewPayment.returnType) }}</el-descriptions-item>

						<!-- 附件信息 -->
						<el-descriptions-item label="回款单" :span="2">
							<el-link v-if="viewPayment.receiptFile" type="primary"
								@click="handleReceiptFilePreview({url:viewPayment.url})">
								查看回款单
							</el-link>
							<span v-else>无</span>
						</el-descriptions-item>

						<!-- 其他信息 -->
						<el-descriptions-item label="备注说明" :span="2"><span
								style="white-space: pre-wrap">{{ viewPayment.remark || '无' }}</span></el-descriptions-item>
					</el-descriptions>
				</el-tab-pane>

				<!-- <el-tab-pane label="审批流程" name="process" v-if="viewPayment.process">
          <el-timeline>
            <el-timeline-item
              v-for="(activity, index) in viewPayment.process"
              :key="index"
              :type="getTimelineItemType(activity.status)"
              :timestamp="formatDateTime(activity.updateTime)">
              <div class="timeline-item-content">
                <h4>第{{ index + 1 }}步</h4>
                <p><strong>审批人：</strong>{{ activity.username }}</p>
                <p><strong>审批状态：</strong>
                  <el-tag :type="getStatusType1(activity.status)" size="small">
                    {{ getStatusText1(activity.status) }}
                  </el-tag>
                </p>
                <p v-if="activity.examineOpinion"><strong>审批意见：</strong>{{ activity.examineOpinion }}</p>
              </div>
            </el-timeline-item>
          </el-timeline>
        </el-tab-pane> -->
			</el-tabs>
		</el-dialog>

		<!-- 审核对话框 -->
		<!-- <el-dialog
      title="回款审核"
      v-model="approveDialogVisible"
      width="500px">
      <el-form
        :model="approveForm"
        :rules="approveRules"
        ref="approveForm"
        label-width="100px">
        <el-form-item label="审核结果" prop="status">
          <el-radio-group v-model="approveForm.status">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审核意见" prop="examineOpinion">
          <el-input
            type="textarea"
            v-model="approveForm.examineOpinion"
            :rows="4"
            placeholder="请输入审核意见" />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="approveDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitApprove" :loading="approveLoading">
            确 定
          </el-button>
        </span>
      </template>
    </el-dialog> -->
	</div>
</template>

<script>
	import {
		Plus,
		Search,
		Refresh
	} from '@element-plus/icons-vue'
	import {
		ElMessage,
		ElMessageBox
	} from 'element-plus'
	import dayjs from 'dayjs'
	import {
		getPaymentList,
		deletePayment,
		createPayment,
		updatePayment,
		submitPayment,
		approvePayment,

		searchCustomers,
		getCustomerOpportunities,
		getOpportunityContracts
	} from '@/api/payment'

	export default {
		name: 'PaymentManagement',
		components: {
			Plus,
			Search,
			Refresh
		},
		data() {
			return {
				loading: false,
				dialogLoading: false,
				submitLoading: false,
				approveLoading: false,
				customerSearchLoading: false,
				contractLoading: false,
				opportunityLoading: false,
				filterForm: {
					type: 'all',
					number: '',
					customerName: '',
					contractNumber: '',
					status: '',
					startDate: '',
					endDate: ''
				},
				dateRange: [],
				paymentList: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				dialogVisible: false,
				viewDialogVisible: false,
				approveDialogVisible: false,
				dialogTitle: '新建回款',
				viewPayment: {},
				currentPayment: null,
				activeTab: 'basic',
				customerOptions: [],
				contractOptions: [],
				opportunityOptions: [],
				uploadHeaders: {
					Authorization: localStorage.getItem('token') || ''
				},
				receiptFileList: [],
				paymentForm: {
					number: '',
					customerId: '',
					businessId: '',
					contractId: '',
					money: 0,
					returnTime: '',
					returnType: '银行转账',
					remark: '',
					receiptFile: ''
				},
				approveForm: {
					status: 1,
					examineOpinion: ''
				},
				rules: {
					number: [{
						required: true,
						message: '请输入回款编号',
						trigger: 'blur'
					}],
					customerId: [{
						required: true,
						message: '请选择客户',
						trigger: 'change'
					}],
					businessId: [{
						required: true,
						message: '请选择商机',
						trigger: 'change'
					}],
					contractId: [{
						required: true,
						message: '请选择合同',
						trigger: 'change'
					}],
					money: [{
						required: true,
						message: '请输入回款金额',
						trigger: 'blur'
					}],
					returnTime: [{
						required: true,
						message: '请选择回款日期',
						trigger: 'change'
					}],
					returnType: [{
						required: true,
						message: '请选择回款方式',
						trigger: 'change'
					}],
					receiptFile: [{
						required: true,
						message: '请上传回款单',
						trigger: 'change'
					}]
				},
				//   approveRules: {
				//     status: [
				//       { required: true, message: '请选择审核结果', trigger: 'change' }
				//     ],
				//     examineOpinion: [
				//       { required: true, message: '请输入审核意见', trigger: 'blur' }
				//     ]
				//   }
			}
		},
		watch: {
			dateRange(val) {
				if (val) {
					this.filterForm.startDate = val[0]
					this.filterForm.endDate = val[1]
				} else {
					this.filterForm.startDate = ''
					this.filterForm.endDate = ''
				}
			}
		},
		created() {
			// 获取路由参数
			const {
				number
			} = this.$route.query
			if (number) {
				// 设置搜索条件
				this.filterForm.number = number
				// 执行搜索
				this.handleSearch()
			} else {
				// 如果没有参数，获取默认列表
				this.fetchData()
			}
		},
		methods: {
			formatDate(date) {
				if (!date) return ''
				return dayjs(date).format('YYYY-MM-DD')
			},
			formatDateTime(date) {
				if (!date) return ''
				return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
			},
			formatAmount(amount) {
				if (!amount && amount !== 0) return '¥0.00'
				return `¥${Number(amount).toFixed(2)}`
			},
			getPaymentMethodText(method) {
				const methodMap = {
					'银行转账': '银行转账',
					'现金': '现金',
					'支票': '支票',
					'其他': '其他'
				}
				return methodMap[method] || method
			},
			getStatusType(status) {
				const statusMap = {
					0: 'warning',
					1: 'success',
					2: 'danger'
				}
				return statusMap[status] || 'info'
			},
			getStatusText(status) {
				const statusMap = {
					0: '未回款',
					1: '已回款',
					2: '已拒绝'
				}
				return statusMap[status] || status
			},
			getStatusType1(status) {
				const statusMap = {
					'-1': 'warning',
					0: 'primary',
					2: 'danger',
					1: 'success'
				}
				return statusMap[status] || 'info'
			},
			getStatusText1(status) {
				const statusMap = {
					'-1': '未进行',
					0: '审批中',
					2: '已拒绝',
					1: '已通过'
				}
				return statusMap[status] || status
			},
			getTimelineItemType(status) {
				const typeMap = {
					'-1': 'warning',
					0: 'primary',
					2: 'danger',
					1: 'success'
				}
				return typeMap[status] || 'info'
			},
			async fetchData() {
				this.loading = true
				try {
					const params = {
						current: this.currentPage,
						size: this.pageSize,
						...this.filterForm
					}
					const res = await getPaymentList(params)
					this.paymentList = res.data.records
					this.total = res.data.total
				} catch (error) {
					console.error('获取回款列表失败:', error)
					ElMessage.error('获取回款列表失败')
				} finally {
					this.loading = false
				}
			},
			handleSearch() {
				this.currentPage = 1
				this.fetchData()
			},
			resetForm() {
				this.filterForm = {
					type: 'all',
					number: '',
					customerName: '',
					contractNumber: '',
					status: '',
					startDate: '',
					endDate: ''
				}
				this.dateRange = []
				this.handleSearch()
			},
			handleSizeChange(val) {
				this.pageSize = val
				this.fetchData()
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.fetchData()
			},
			handleAdd() {
				this.dialogTitle = '新建回款'
				this.paymentForm = {
					number: '',
					customerId: '',
					businessId: '',
					contractId: '',
					money: 0,
					returnTime: '',
					returnType: '银行转账',
					remark: '',
					receiptFile: ''
				}
				this.receiptFileList = []
				this.dialogVisible = true
			},
			handleEdit(row) {
				this.dialogTitle = '编辑回款'
				this.customerOptions = [{
					id: row.customerId,
					customerName: row.customerName
				}]
				this.opportunityOptions = [{
					id: row.businessId,
					name: row.businessName
				}]
				this.contractOptions = [{
					id: row.contractId,
					contractNumber: row.contractNo,
					totalAmount: row.totalAmount
				}]
				this.paymentForm = {
					...row
				}
				if (row.receiptFile) {
					this.receiptFileList = [{
						name: row.receiptFile.split('/').pop(),
						url: '/api/move/getMinRes?name=' + row.receiptFile
					}]
				}
				this.dialogVisible = true
			},
			async handleView(row) {
				this.viewDialogVisible = true
				try {


					this.viewPayment = {
						...row
					}
				} catch (error) {
					console.error('获取回款详情失败:', error)
					ElMessage.error('获取回款详情失败')
				}
			},
			handleSubmit(row) {
				ElMessageBox.confirm('确认提交该回款进行审核吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					try {
						await submitPayment(row.id)
						ElMessage.success('提交成功')
						this.fetchData()
					} catch (error) {
						console.error('提交回款失败:', error)
						ElMessage.error('提交失败')
					}
				}).catch(() => {})
			},
			handleApprove(row) {
				this.currentPayment = row
				this.approveForm = {
					status: 1,
					examineOpinion: ''
				}
				this.approveDialogVisible = true
			},
			async handleCustomerSearch(query) {
				if (query) {
					this.customerSearchLoading = true
					try {
						const res = await searchCustomers({
							name: query
						})
						this.customerOptions = res.data
					} catch (error) {
						console.error('搜索客户失败:', error)
						ElMessage.error('搜索客户失败')
					} finally {
						this.customerSearchLoading = false
					}
				} else {
					this.customerOptions = []
				}
			},
			async handleCustomerChange(customerId) {
				if (customerId) {
					this.opportunityLoading = true
					try {
						const res = await getCustomerOpportunities({
							cuId: customerId
						})
						this.opportunityOptions = res.data
					} catch (error) {
						console.error('获取客户商机失败:', error)
						ElMessage.error('获取客户商机失败')
					} finally {
						this.opportunityLoading = false
					}
				} else {
					this.opportunityOptions = []
					this.contractOptions = []
				}
				this.paymentForm.businessId = ''
				this.paymentForm.contractId = ''
			},
			async handleOpportunityChange(businessId) {
				if (businessId) {
					this.contractLoading = true
					try {
						const res = await getOpportunityContracts({
							id: businessId
						})
						this.contractOptions = res.data
					} catch (error) {
						console.error('获取商机合同失败:', error)
						ElMessage.error('获取商机合同失败')
					} finally {
						this.contractLoading = false
					}
				} else {
					this.contractOptions = []
				}
				this.paymentForm.contractId = ''
			},
			async submitForm() {
				try {
					await this.$refs.paymentForm.validate()
					this.submitLoading = true

					if (this.paymentForm.id) {
						await updatePayment(this.paymentForm)
						ElMessage.success('更新成功')
					} else {
						await createPayment(this.paymentForm)
						ElMessage.success('创建成功')
					}
					this.dialogVisible = false
					this.fetchData()
				} catch (error) {
					if (error.message) {
						ElMessage.error(error.message)
					}
					console.error('提交表单失败:', error)
				} finally {
					this.submitLoading = false
				}
			},
			async submitApprove() {
				try {
					await this.$refs.approveForm.validate()
					this.approveLoading = true

					await approvePayment(this.currentPayment.id, this.approveForm)
					ElMessage.success('审核成功')
					this.approveDialogVisible = false
					this.fetchData()
				} catch (error) {
					if (error.message) {
						ElMessage.error(error.message)
					}
					console.error('提交审核失败:', error)
				} finally {
					this.approveLoading = false
				}
			},
			// 回款单上传相关方法
			handleReceiptFilePreview(file) {
				window.open(file.url)
			},
			handleReceiptFileRemove() {
				this.paymentForm.receiptFile = ''
				this.receiptFileList = []
			},
			handleReceiptFileSuccess(response, file) {
				this.paymentForm.receiptFile = response.data
				this.receiptFileList = [{
					name: file.name,
					url: '/api/move/getMinRes?name=' + response.data
				}]
			},
			beforeReceiptFileUpload(file) {
				// 更新 token，以防 token 过期
				this.uploadHeaders.Authorization = localStorage.getItem('token') || ''

				const isPDF = file.type === 'application/pdf'
				const isImage = file.type.startsWith('image/')
				const isLt10M = true

				if (!isPDF && !isImage) {
					ElMessage.error('只能上传PDF或图片文件!')
					return false
				}
				if (!isLt10M) {
					ElMessage.error('文件大小不能超过 10MB!')
					return false
				}
				return true
			},
			handleReceiptFileExceed() {
				ElMessage.warning('只能上传一个文件')
			},
			async handleDelete(row) {
				try {
					await this.$confirm('确认删除该回款记录吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					await deletePayment({
						id: row.id
					})
					this.$message.success('删除成功')
					this.fetchData()
				} catch (error) {
					if (error !== 'cancel') {
						console.error('删除回款记录失败:', error)
						this.$message.error('删除失败')
					}
				}
			},
		}
	}
</script>

<style scoped>
	.timeline-item-content {
		padding: 8px 0;
	}

	.timeline-item-content h4 {
		margin: 0 0 8px 0;
		color: #303133;
	}

	.timeline-item-content p {
		margin: 4px 0;
		color: #606266;
		line-height: 1.5;
	}

	.el-dialog {
		display: flex;
		flex-direction: column;
		margin: 0 !important;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		max-height: calc(100vh - 30px);
		max-width: calc(100vw - 30px);
	}

	.el-dialog__body {
		flex: 1;
		overflow: auto;
		padding: 20px;
	}

	.el-timeline {
		margin: 0;
		padding: 0;
	}

	.el-divider {
		margin: 24px 0;
	}

	.el-divider__text {
		font-size: 16px;
		font-weight: bold;
		color: #303133;
	}

	.receipt-upload {
		width: 100%;
	}

	.receipt-upload :deep(.el-upload-list) {
		width: 100%;
	}

	.receipt-upload :deep(.el-upload-list__item) {
		width: 100%;
	}
</style>
